<template>
    <div class="warpNavlan" ref="supplyRef">
         <div class="box-one" ref="gsap-context">
           <div class="center">
             <div>
               <span>
                供应链优势
               </span>
             </div>
           </div>
         </div>
         <div class="box-two" ref="gsap-box">
           <div class="context">
             <div class="context-one">
             </div>
             <div class="context-two">
                <div class="text-one">
                    加入繁淼有保障
                </div>
                <div class="text-two"></div>
                <div class="text-three">
                    <!-- <div style="border: 1px solid rgba(0,0,0,0.1);padding: 10px;box-sizing: border-box;border-radius: 10px;"> -->
                      公司已与上游有机农场达成合作，对供应链的上游把控能力强，灵活性高，货源品质有保障。
                    <!-- </div> -->
                </div>
                <div class="text-four">
                    <!-- <div style="border: 1px solid rgba(0,0,0,0.1);padding: 10px;box-sizing: border-box;border-radius: 10px;"> -->
                      我们拥有完善的供应链体系和采购渠道，能够帮助您降低成本并提高利润。我们还将为您提供详细的经营指导和成本控制方案，以确保您的加盟店能够正常运营，实现盈利。
                    <!-- </div> -->
                </div>
                <div class="text-five">
                    <div class="text-box-one">
                        <!-- <div class="box-one">100</div> -->
                        <CountTo :start-val="0" :end-val="100" :duration="1500" class="box-one"></CountTo>
                        <div class="box-title">已有供应链</div>
                    </div>
                    <div class="box-line"></div>
                    <div class="text-box-two">
                        <!-- <div class="box-one">14</div> -->
                        <CountTo :start-val="0" :end-val="14" :duration="3500" class="box-one"></CountTo>
                        <div class="box-title">已有合作商</div>
                    </div>
                </div>
             </div>
           </div>
         </div>
    </div>
 </template>
 <script>
 import CountTo from 'vue-count-to'
 import { gsap } from 'gsap'
 export default {
   name: 'child',
   components:{
    // 数字滚动器
    CountTo
   },
   data(){
     return{
        
     }
   },
   mounted() { 
    this.initAnFun();
   },
   methods:{
    initAnFun(){

      let observer = new IntersectionObserver((enter)=>{
        if(enter[0].isIntersecting){
            let title = this.$refs['gsap-context'];
            let box = this.$refs['gsap-box'];

            gsap.from(title,{
              y:'-100%',
              duration: 3.6,
              ease:'power2.out'
            })
            gsap.from(title,{
              opacity:1,
              duration: 3,
              ease:'power2.out'
            })
            gsap.from(box,{
              y:'100%',
              duration:3.6,
              ease:'power2.out'
            })
          observer.unobserve(this.$refs.supplyRef)
        }
      },{
        root: null,
        threshold: 0.3
      })
      observer.observe(this.$refs.supplyRef)
    }
   }
 }
 </script>
 <style lang="scss" scoped>
     .warpNavlan{
       width: 100%;
       height: 1080px;
       background: #FFFFFF;
       position: relative;
       box-sizing: border-box;
       padding-top: 106px;
       background-image: url('../../../assets/supply-bg.png');
       background-size: 100% 100%;
       .box-one{
         width: 100%;
         display: flex;
         justify-content: center;
         margin-bottom: 83px;
         .center{
           width: 960px;
           height: 98px;
           background-image: url('../../../assets/supply-title.png');
           background-size: 100% 100%;
           div{
             height: 100%;
             display: flex;
             justify-content: center;
             align-items: flex-end;
 
             span{
               font-size: 40px;
               font-family: Alibaba_Bold;
               color: #333333;
               line-height: 56px;
             }
           }
         }
         // 
       }
       .box-two{
         display: flex;
         justify-content: center;
         .context{
           width: 1200px;
           height: 524px;
           display: flex;
           overflow: hidden;
           background: #FFFFFF;
           box-shadow: 0px 5px 32px -2px rgba(192,196,200,0.5);
           border-radius: 10px;
           .context-one{
             width: 552px;
             height: 100%;
             background-image: url('../../../assets/supply-bg1.png');
             background-size: 100% 100%;
             box-sizing: border-box;
             padding-top: 289px;
             padding-left: 40px;
           }
           .context-two{
             width: calc(100% - 552px);
             height: 100%;
             box-sizing: border-box;
             padding-top: 100px;
             box-sizing: border-box;
             padding-left: 60px;
             padding-top: 50px;
             padding-right: 50px;
             .text-one{
                font-size: 32px;
                font-family: Alibaba_Bold;
                color: #333333;
                line-height: 45px;
                margin-bottom: 18px;
             }
             .text-two{
                width: 34px;
                height: 5px;
                background: linear-gradient(90deg, #367CFF 0%, #80ACFF 100%);
                margin-bottom: 50px;
             }
             .text-three{
                font-size: 14px;
                font-family: Alibaba_Regular;
                font-weight: 400;
                color: #333333;
                line-height: 24px;
             }
             .text-four{
                @extend .text-three;
                margin-top: 13px;
                margin-bottom: 62px;
             }
             .text-five{
                display: flex;
                .text-box-one{
                    display: flex;
                    flex-direction: column;
                    .box-one{
                        font-size: 56px;
                        font-family: Alibaba_Bold;
                        font-weight: bold;
                        color: #333333;
                        position: relative;
                        height: 0px;
                        &::after{
                            content: "+";
                            position: absolute;
                            font-size: 32px;
                            right: -20px;
                            top: 25px;
                        }
                    }
                    .box-title{
                        font-size: 14px;
                        font-family: Alibaba_Regular;
                        font-weight: 400;
                        color: #93979A;
                        line-height: 20px;
                        box-sizing: border-box;
                        padding-left: 5px;
                    }
                }
                .box-line{
                    width: 1px;
                    height: 42px;
                    background: #E5E7E7;
                    margin-left: 80px;
                    margin-right: 60px;
                    margin-top: 30px;
                }
                .text-box-two{
                    display: flex;
                    flex-direction: column;
                    .box-one{
                        font-size: 56px;
                        font-family: Alibaba_Bold;
                        font-weight: bold;
                        color: #333333;
                        position: relative;
                        height: 0px;
                        &::after{
                            content: "+";
                            position: absolute;
                            font-size: 32px;
                            right: -20px;
                            top: 25px;
                        }
                    }
                    .box-title{
                        font-size: 14px;
                        font-family: Alibaba_Regular;
                        font-weight: 400;
                        color: #93979A;
                        line-height: 20px;
                        box-sizing: border-box;
                        padding-left: 5px;
                    }
                }
             }
           }
         }
       }
     }
 </style>
 
 